import request from '@/utils/request'

/**
 * 业务类型当月录入数量统计
 */
export function getEntryStatsByMonth() {
  return request({
    url: '/student/stats/entry-by-month',
    method: 'get'
  })
}

/**
 * 业务类型上月录入数量统计
 */
export function getEntryStatsByLastMonthPeriod() {
  return request({
    url: '/student/stats/entry-by-last-month-period',
    method: 'get'
  })
}
